var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter } from '../event-emitter';
import { MPEGDecoder } from 'mpg123-decoder';
import { createBuffer } from '../utils';
var AudioPlayer = (function (_super) {
    __extends(AudioPlayer, _super);
    function AudioPlayer() {
        var _this = _super.call(this) || this;
        _this.audioQueue = [];
        _this.audioBufferQueue = [];
        _this.currentSourceNode = null;
        _this.mediaElementSource = null;
        _this.decoder = new MPEGDecoder();
        if (navigator.userAgent.includes('Firefox')) {
            _this.browser = 'Firefox';
        }
        else if (navigator.userAgent.includes('Chrome')) {
            _this.browser = 'Chrome';
        }
        else if (navigator.userAgent.includes('Safari')) {
            _this.browser = 'Safari';
        }
        else if (navigator.userAgent.includes('MSIE') ||
            navigator.userAgent.includes('Trident/')) {
            _this.browser = 'IE';
        }
        else {
            _this.browser = 'Unknown';
        }
        return _this;
    }
    AudioPlayer.prototype._initializeAudioPlayer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var condition, audioProcessorCode, audioProcessorBlob, audioProcessorUrl, audioProcessorNode;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        condition = this.browser === 'Safari' || this.browser === 'Firefox'
                            ? false
                            : !!window.MediaSource && MediaSource.isTypeSupported('audio/mpeg');
                        if (!condition) return [3, 2];
                        this.mediaSource = new MediaSource();
                        this.audio.src = URL.createObjectURL(this.mediaSource);
                        this.mediaSource.addEventListener('sourceopen', function () {
                            _this._initializeSourceBuffer();
                        });
                        audioProcessorCode = "\n        class AudioProcessor extends AudioWorkletProcessor {\n          process(inputs, outputs, parameters) {\n            const input = inputs[0];\n            const output = outputs[0];\n\n            for (let channel = 0; channel < input.length; ++channel) {\n              const inputChannel = input[channel];\n              const outputChannel = output[channel];\n\n              if (!outputChannel) {\n                console.warn('WARNING: Output channel ' + channel + ' not found');\n                // for some reason, we need to just let this worklet crash\n                // if we try to gracefully recover from this, the worklet just keeps looping and never recovers\n              }\n\n              // Copy input data to output\n              for (let i = 0; i < inputChannel.length; ++i) {\n                outputChannel[i] = inputChannel[i];\n              }\n            }\n\n            this.port.postMessage(input);\n            return true;\n          }\n        }\n\n        registerProcessor(\"audio-processor\", AudioProcessor);\n        ";
                        audioProcessorBlob = new Blob([audioProcessorCode], {
                            type: 'text/javascript',
                        });
                        audioProcessorUrl = URL.createObjectURL(audioProcessorBlob);
                        return [4, this.playingAudioContext.audioWorklet.addModule(audioProcessorUrl)];
                    case 1:
                        _a.sent();
                        audioProcessorNode = new AudioWorkletNode(this.playingAudioContext, 'audio-processor');
                        this.mediaElementSource =
                            this.playingAudioContext.createMediaElementSource(this.audio);
                        this.mediaElementSource.connect(this.playingAudioContext.destination);
                        this.mediaElementSource.connect(audioProcessorNode);
                        audioProcessorNode.port.onmessage = function (event) {
                            var float32Array = event.data[0];
                            if (!Array.isArray(float32Array)) {
                                _this._setIsAISpeaking(false);
                                return;
                            }
                            if (float32Array[0] === 0 && float32Array[10] === 0) {
                                _this._setIsAISpeaking(false);
                            }
                            else {
                                _this._setIsAISpeaking(true);
                            }
                        };
                        return [3, 4];
                    case 2: return [4, this.decoder.ready];
                    case 3:
                        _a.sent();
                        document.body.addEventListener('click', function () {
                            if (_this.playingAudioContext.state === 'suspended') {
                                _this.playingAudioContext.resume();
                            }
                        });
                        _a.label = 4;
                    case 4: return [2];
                }
            });
        });
    };
    AudioPlayer.prototype._startPlaying = function () {
        return __awaiter(this, void 0, void 0, function () {
            var condition, e_1, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        condition = this.browser === 'Safari' || this.browser === 'Firefox'
                            ? false
                            : !!window.MediaSource && MediaSource.isTypeSupported('audio/mpeg');
                        if (!condition) return [3, 8];
                        if (this.mediaSource && this.mediaSource.readyState !== 'open') {
                            this.mediaSource.addEventListener('sourceopen', this._startPlaying, {
                                once: true,
                            });
                            return [2];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.audio.play()];
                    case 2:
                        _a.sent();
                        return [3, 4];
                    case 3:
                        e_1 = _a.sent();
                        return [3, 4];
                    case 4:
                        _a.trys.push([4, 6, , 7]);
                        return [4, this.updateSourceBuffer()];
                    case 5:
                        _a.sent();
                        return [3, 7];
                    case 6:
                        error_1 = _a.sent();
                        return [3, 7];
                    case 7:
                        this._isPlaying = true;
                        if (this._startAnalyser) {
                            this._startAnalyser();
                        }
                        return [3, 9];
                    case 8:
                        this._playWebAudioBufferQueue();
                        this._startAnalyser();
                        _a.label = 9;
                    case 9: return [2];
                }
            });
        });
    };
    AudioPlayer.prototype._stopPlaying = function () {
        return __awaiter(this, arguments, void 0, function (shouldLogSpeechEnd) {
            var condition;
            var _a;
            if (shouldLogSpeechEnd === void 0) { shouldLogSpeechEnd = true; }
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.audioQueue = [];
                        try {
                            this.audio.pause();
                        }
                        catch (error) { }
                        condition = this.browser === 'Safari' || this.browser === 'Firefox'
                            ? false
                            : !!window.MediaSource && MediaSource.isTypeSupported('audio/mpeg');
                        if (!condition) return [3, 2];
                        if (((_a = this.mediaSource) === null || _a === void 0 ? void 0 : _a.readyState) === 'open' &&
                            (this === null || this === void 0 ? void 0 : this.mediaSource.sourceBuffers.length) > 0) {
                            this.sourceBuffer.abort();
                        }
                        return [4, this._reinitializeMediaSource()];
                    case 1:
                        _b.sent();
                        return [3, 3];
                    case 2:
                        if (this.currentSourceNode) {
                            this.currentSourceNode.stop();
                            this.currentSourceNode.disconnect();
                            this.currentSourceNode = null;
                        }
                        this.audioBufferQueue = [];
                        _b.label = 3;
                    case 3:
                        this._stopAnalyser();
                        this._isAISpeaking = false;
                        this._isPlaying = false;
                        return [2];
                }
            });
        });
    };
    AudioPlayer.prototype._initializeAudio = function () {
        this.audio = new Audio();
        this.playingAudioContext = new (window.AudioContext || window.webkitAudioContext)({
            sampleRate: 44100,
        });
    };
    AudioPlayer.prototype.playAudio = function () {
        return __awaiter(this, void 0, void 0, function () {
            var condition;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        condition = this.browser === 'Safari' || this.browser === 'Firefox'
                            ? false
                            : !!window.MediaSource && MediaSource.isTypeSupported('audio/mpeg');
                        if (!condition) return [3, 2];
                        return [4, this.updateSourceBuffer()];
                    case 1:
                        _a.sent();
                        return [3, 4];
                    case 2: return [4, this.updateWebAudioBuffer()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2];
                }
            });
        });
    };
    AudioPlayer.prototype.updateWebAudioBuffer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var chunk, audioBuffer;
            return __generator(this, function (_a) {
                if (this.audioQueue.length > 0) {
                    chunk = this.audioQueue.shift();
                    try {
                        audioBuffer = createBuffer(this.decoder.decode(new Uint8Array(chunk)));
                        this.audioBufferQueue.push(audioBuffer);
                        this._playWebAudioBufferQueue();
                    }
                    catch (error) {
                    }
                }
                return [2];
            });
        });
    };
    AudioPlayer.prototype._playWebAudioBufferQueue = function () {
        var _this = this;
        if (!this._isPlaying && this.audioBufferQueue.length > 0) {
            this._isPlaying = true;
            var buffer = this.audioBufferQueue.shift();
            this.currentSourceNode = this.playingAudioContext.createBufferSource();
            this.currentSourceNode.buffer = buffer;
            this.currentSourceNode.connect(this.analyser);
            this.currentSourceNode.start();
            this.currentSourceNode.onended = function () {
                _this._isPlaying = false;
                _this._playWebAudioBufferQueue();
            };
        }
    };
    AudioPlayer.prototype.updateSourceBuffer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var chunk;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.sourceBuffer &&
                            !this.sourceBuffer.updating &&
                            this.audioQueue.length > 0 &&
                            this.mediaSource.sourceBuffers.length > 0)) return [3, 2];
                        chunk = this.audioQueue.shift();
                        this.sourceBuffer.appendBuffer(chunk);
                        return [4, this._waitForBufferUpdateEnd()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2];
                }
            });
        });
    };
    AudioPlayer.prototype._waitForBufferUpdateEnd = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2, new Promise(function (resolve) {
                        _this.sourceBuffer.addEventListener('updateend', resolve, { once: true });
                    })];
            });
        });
    };
    AudioPlayer.prototype._initializeSourceBuffer = function () {
        var _this = this;
        if (this.mediaSource.readyState === 'open') {
            this.sourceBuffer = this.mediaSource.addSourceBuffer('audio/mpeg');
            this.sourceBuffer.mode = 'sequence';
            this.sourceBuffer.addEventListener('updateend', function () {
                _this.updateSourceBuffer.bind(_this)();
            });
        }
    };
    AudioPlayer.prototype._reinitializeMediaSource = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.mediaSource) {
                            if (this.mediaSource.readyState === 'open') {
                                this.mediaSource.endOfStream();
                            }
                            this.audio.src = '';
                            URL.revokeObjectURL(this.audio.src);
                        }
                        this.mediaSource = new MediaSource();
                        this.audio.src = URL.createObjectURL(this.mediaSource);
                        return [4, new Promise(function (resolve) {
                                _this.mediaSource.addEventListener('sourceopen', function () {
                                    _this._initializeSourceBuffer();
                                    resolve();
                                }, { once: true });
                            })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    AudioPlayer.prototype._setIsAISpeaking = function (isSpeaking, onStartingSpeakingCB, onStoppedSpeakingCB) {
        if (isSpeaking && this._isAISpeaking) {
            return;
        }
        if (!isSpeaking && !this._isAISpeaking) {
            return;
        }
        if (!isSpeaking && this._isAISpeaking) {
            this._isAISpeaking = false;
        }
        else if (isSpeaking && !this._isAISpeaking) {
            this._isAISpeaking = true;
        }
    };
    AudioPlayer.prototype.isAISpeaking = function () {
        return this._isAISpeaking;
    };
    AudioPlayer.prototype._startAnalyser = function () {
        if (!this.analyser) {
            this.analyser = this.playingAudioContext.createAnalyser();
            this.analyser.fftSize = 256;
            this.emitAmplitudeInterval();
        }
        var condition = this.browser === 'Safari' || this.browser === 'Firefox'
            ? false
            : !!window.MediaSource && MediaSource.isTypeSupported('audio/mpeg');
        if (condition) {
            this.mediaElementSource.connect(this.analyser);
        }
        this.analyser.connect(this.playingAudioContext.destination);
    };
    AudioPlayer.prototype._stopAnalyser = function () {
        if (this.analyser) {
            this.analyser.disconnect();
            if (this._emitAmplitudeInterval) {
                clearInterval(this._emitAmplitudeInterval);
                this._emitAmplitudeInterval = null;
                this.analyser = null;
                this.emit('ai_speech_amplitude', 0);
            }
        }
    };
    AudioPlayer.prototype.emitAmplitudeInterval = function () {
        var _this = this;
        var bufferLength = this.analyser.frequencyBinCount;
        var dataArray = new Uint8Array(bufferLength);
        var amplitudeMultiplier = 10;
        this._emitAmplitudeInterval = setInterval(function () {
            _this.analyser.getByteFrequencyData(dataArray);
            var sum = 0;
            for (var i = 0; i < bufferLength; i++) {
                sum += dataArray[i];
            }
            var average = sum / bufferLength;
            if (average / 256 > 0.1) {
                _this.emit('ai_speech_amplitude', (average / 256) * amplitudeMultiplier);
            }
            else {
                _this.emit('ai_speech_amplitude', 0);
            }
        }, 100);
    };
    return AudioPlayer;
}(EventEmitter));
export default AudioPlayer;
